import { render, staticRenderFns } from "./sondict.vue?vue&type=template&id=64fd46a0"
import script from "./sondict.vue?vue&type=script&lang=js"
export * from "./sondict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports